// src/serviceWorker.js

export async function register() {
    if (navigator.serviceWorker) {
        window.addEventListener("load", () => {
            navigator.serviceWorker
                .register("/firebase-messaging-sw.js")
                .then(() => {
                    console.log("SW registered")
                })
                .catch((error) => {
                    console.error("SW registration failed", error)
                })
        })
    }
}

export async function unregister() {
    if (navigator.serviceWorker) {
        navigator.serviceWorker.ready.then((registration) => {
            registration.unregister()
        })
    }
}
